// Single source of truth for storefront branding.
// Edit these values to rebrand without touching the UI code.

export const BRANDING = {
  storeName: "The Wyld Lilac",
  storeNameAccent: "",   // Optional small accent after the main name
  tagline: "Digital tools for real life, big ideas & a little magic.",
  heroEyebrow: "Instant digital downloads",
  heroCtaPrimary: "Shop Digital Products",
  heroCtaSecondary: "Browse categories",
  heroImageUrl:
    "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxsYXB0b3AlMjBkZXNrJTIwbWluaW1hbHxlbnwwfHx8fDE3OTEwMDI5OTB8MA&ixlib=rb-4.1.0&q=85",
  trust: [
    { title: "Instant Digital Downloads", body: "Grab your file the moment payment clears." },
    { title: "Secure Checkout", body: "Payments processed by Stripe. Your info stays safe." },
    { title: "Download Again Anytime", body: "Your link stays live for 30 days and 10 downloads." },
  ],
};

// Primary category deck shown on the homepage.
// `slug` MUST match a backend category slug.
export const CATEGORY_DECK = [
  { slug: "business-money",        name: "Business & Money",        blurb: "Side-hustles, budgets, launching your thing." },
  { slug: "templates-printables",  name: "Templates & Printables",  blurb: "Planners, worksheets and done-for-you layouts." },
  { slug: "diy-howto",             name: "DIY & How-To Guides",     blurb: "Step-by-step guides for everyday projects." },
  { slug: "wellness-lifestyle",    name: "Wellness & Lifestyle",    blurb: "Rituals, routines and feel-good resets." },
  { slug: "spiritual-tarot",       name: "Spiritual & Tarot",       blurb: "Reflection, journaling and tarot workbooks." },
  { slug: "home-organization",     name: "Home & Organization",     blurb: "Checklists, cleaning plans and home resets." },
  { slug: "travel",                name: "Travel",                  blurb: "Itineraries, packing lists and travel kits." },
  { slug: "creator-resources",     name: "Creator Resources",       blurb: "Content calendars, kits for makers & creators." },
];
